import { api } from "./client";
import type {
  Device,
  DeviceCreate,
  DeviceRemocao,
  DeviceReplaceIn,
  DeviceReplaceOut,
  DeviceSummary,
  DeviceUpdate,
  OrphanDevice,
} from "@/types";

export interface DeviceListFilters {
  site_id?: string;
  equipment_id?: string;
  tenant_id?: string;
  role?: string;
  kind?: string;
  /** Se true, inclui devices desativados. Default só ativos. */
  include_inactive?: boolean;
}

export const devicesApi = {
  async list(filters?: DeviceListFilters): Promise<Device[]> {
    const { data } = await api.get<Device[]>("/devices", { params: filters });
    return data;
  },
  async listInSite(siteId: string): Promise<Device[]> {
    const { data } = await api.get<Device[]>(`/sites/${siteId}/devices`);
    return data;
  },
  async get(id: string): Promise<Device> {
    const { data } = await api.get<Device>(`/devices/${id}`);
    return data;
  },
  async summary(id: string): Promise<DeviceSummary> {
    const { data } = await api.get<DeviceSummary>(`/devices/${id}/summary`);
    return data;
  },
  async fields(id: string, sinceHours = 24): Promise<string[]> {
    const { data } = await api.get<string[]>(`/devices/${id}/readings-fields`, {
      params: { since_hours: sinceHours },
    });
    return data;
  },
  async create(payload: DeviceCreate): Promise<Device> {
    const { data } = await api.post<Device>("/devices", payload);
    return data;
  },
  async update(id: string, payload: DeviceUpdate): Promise<Device> {
    const { data } = await api.patch<Device>(`/devices/${id}`, payload);
    return data;
  },
  /**
   * Remove o device. O servidor decide entre apagar e desativar conforme
   * exista histórico de leituras, e devolve qual das duas fez — a tela
   * precisa saber pra não dizer "deletado" sobre algo que continua na lista.
   */
  async remove(id: string): Promise<DeviceRemocao> {
    const { data } = await api.delete<DeviceRemocao>(`/devices/${id}`);
    return data;
  },
  /**
   * Substitui o sensor `id` por outro na mesmo ativo.
   *
   * Sem `confirmar` o servidor devolve a PRÉVIA e não altera nada — é o que
   * alimenta o modal antes de a pessoa apertar o botão.
   */
  async replace(id: string, payload: DeviceReplaceIn): Promise<DeviceReplaceOut> {
    const { data } = await api.post<DeviceReplaceOut>(
      `/devices/${id}/substituir`, payload,
    );
    return data;
  },
  async orphans(): Promise<OrphanDevice[]> {
    const { data } = await api.get<OrphanDevice[]>("/orphan-devices");
    return data;
  },
};
